<div class="theme-section-header theme-border-y theme-border-l" style="padding: 18px 9px 18px 20px;">
  <div
    class="section-title" [translate]="'test_machine.details.quick_info.header' | translate">
  </div>
  <div class="ml-auto">
    <i
      class="fa-close-alt  action-hover-icon"
      (click)="toggleDetails(true)"
      [matTooltip]="'btn.common.close' | translate"></i>
  </div>
</div>
<div class="theme-quick-container">
  <div class="d-flex">

    <div class="highChart">
      <app-result-donut-chart
        [width]="118"
        [height]="118"
        [resultEntity]="suiteResultResult"></app-result-donut-chart>
    </div>

    <div class="legend-container ml-14 w-100 text-right">
      <div class="legend-item" (click)="filter(resultConstant.SUCCESS)">
        <i
          class="result-status-0 fa-show legend-icon btn">
        </i>
        <span [textContent]="('execution.result.SUCCESS' | translate) +
        ' : '+ suiteResultResult.passedCount+''"></span>
      </div>
      <div class="legend-item" (click)="filter(resultConstant.FAILURE)">
        <i
          class="result-status-1 fa-show legend-icon btn result-status-active-1">
        </i>
        <span [textContent]="('execution.result.FAILURE' | translate) +
        ' : '+ suiteResultResult.failedCount+''"></span>
      </div>
      <div class="legend-item" (click)="filter(resultConstant.ABORTED)">
        <i
          class="result-status-2 fa-show legend-icon btn result-status-active-2">
        </i>
        <span [textContent]="('execution.result.ABORTED' | translate) +
        ' : '+ suiteResultResult.abortedCount+''"></span>
      </div>
      <div class="legend-item" (click)="filter(resultConstant.NOT_EXECUTED)">
        <i
          class="result-status-3 fa-show legend-icon btn result-status-active-3">
        </i>
        <span [textContent]="('execution.result.NOT_EXECUTED' | translate) +
        ' : '+ suiteResultResult.notExecutedCount+''"></span>
      </div>
      <div class="legend-item" (click)="filter(resultConstant.QUEUED)">
        <i
          class="result-status-5 fa-show legend-icon btn result-status-active-5">
        </i>
        <span [textContent]="('execution.result.QUEUED' | translate) +
        ' : '+ suiteResultResult.queuedCount+''"></span>
      </div>
      <div class="legend-item" (click)="filter(resultConstant.STOPPED)">
        <i
          class="result-status-6 fa-show legend-icon btn result-status-active-6">
        </i>
        <span [textContent]="('execution.result.STOPPED' | translate) +
        ' : '+ suiteResultResult.stoppedCount+''"></span>
      </div>

      <div class="legend-item theme-border-t mt-5">
        <span class="white-space-nowrap" [textContent]="('execution.result.test_case.total' | translate) +
        ' : '+ suiteResultResult.totalCount+''"></span>
      </div>
    </div>

  </div>

  <div class="details-container sm value-sm flex-column align-items-baseline pt-30">
    <div class="details-items">
      <label
        class="details-title"
        [translate]="'result.start_time'"></label>
      <div class="details-info d-flex">
        <span
          [textContent]="suiteResultResult?.startTime  | date:'h:mm a MMM d, y'"></span>
        <span class="d-flex pl-7">
          <span [textContent]="'( '"></span>
          <app-duration-format [duration]="suiteResultResult?.duration"></app-duration-format>
          <span [textContent]="' )'"></span>
        </span>
      </div>
    </div>

    <div class="details-items text-break" *ngIf="suiteResultResult?.testDeviceResult?.environmentId">
      <label
        class="details-title"
        [translate]="'runs.details.environment'"></label>
      <div class="details-info"
           [textContent]="suiteResultResult?.testDeviceResult?.testPlanResult?.environment?.name || '-'"></div>
    </div>

    <div class="details-items">
      <label
        class="details-title"
        [translate]="'message.common.msg'"></label>
      <div class="details-info text-wrap"
           [textContent]="suiteResultResult?.message"></div>
    </div>
  </div>
</div>
